export class Deferred<T> {
  public readonly promise: Promise<T>
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public resolve: (result: T | PromiseLike<T>) => void = () => {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public reject: (reason: Error) => void = () => {}

  constructor() {
    this.promise = new Promise<T>((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject as (reason: Error) => void
    })
  }
}
